import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule as BluecrewCommonModule } from '../common/common.module';

import { AssessmentPageComponent } from './assessment.page';

import { AssessmentPageRoutingModule } from './assessment-routing.module';
import { PipeModule } from '../pipes/pipe.module';
import { ScreenPartDateTimeComponent } from './screen-parts/screen-part-date-time/screen-part-date-time.component';
import { ScreenPartUploadImageComponent } from './screen-parts/screen-part-upload-image/screen-part-upload-image.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AssessmentPageRoutingModule,
    ReactiveFormsModule,
    PipeModule,
    BluecrewCommonModule,
  ],
  declarations: [
    AssessmentPageComponent,
    ScreenPartDateTimeComponent,
    ScreenPartUploadImageComponent
  ]
})
export class AssessmentPageModule {}
